import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import CancelIcon2 from '@material-ui/icons/Cancel';
import iconSalonOpen from 'images/icon_salon_open.svg'

import CopyToClipboard from 'react-copy-to-clipboard'
import { LineShareButton } from 'react-share'
import TwitterLogo from 'images/redesign/icon_sns_twitter_color.svg'
import LineLogo from 'images/redesign/icon_sns_line_color.svg'
import LinkIcon from 'images/redesign/icon_sns_link_color.svg'
import alertModules from '../../modules/alert'
import awsconfig from 'aws-exports'
import XShareButton from 'components/common/XShareButton'
import { getMeDoorV1, MeDoorResponse } from 'apis/doors'

interface Props {
  doorId: string
  open: boolean
  published: boolean
  handleClose: () => void
  handlePublish: () => any
  disabled: boolean
}

export default function ConfirmPublishModal(props: Props) {
  const {
    doorId: doorId,
    open,
    handleClose,
    handlePublish,
    published,
    disabled
  } = props

  const dispatch = useDispatch()
  const [door, setDoor] = useState<MeDoorResponse|null>(null)
  const shareUrl = `${awsconfig.yoor_share_url_base}/door/${doorId}`

  useEffect(() => {
    getMeDoorV1(doorId).then(response => setDoor(response.data))
  }, [])
  
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <section className="modal" id="modal-door">
        {published ? (
          <>
            <div className="modal-header">
              <div
                className="title"
                style={{ paddingTop: '40px', borderBottom: '0' }}
              >
                サロンを公開しました！
              </div>
              <div className="close modal-close">
                <CancelIcon2 onClick={handleClose} />
              </div>
            </div>
            <div className="modal-contents" style={{ padding: '0 0 40px' }}>
              <div className="text-center">
                <img
                  src={iconSalonOpen}
                  alt="iconSalonOpen"
                  width="141"
                  height="123"
                />
              </div>
              <div style={{textAlign: 'center'}}>
                サロンの公開準備お疲れ様でした<br/>
                あなたのサロンをみんなに広めましょう！
              </div>
              <div className="mt3">
                <SocialButtons>
                  <li>
                    <XShareButton title={`${door?.door?.title} - ${door?.owner.name}`} url={shareUrl}>
                      <img src={TwitterLogo} alt="twitter" />
                    </XShareButton>
                  </li>
                  <li>
                    <LineShareButton
                      title={`${door?.door?.title} - ${door?.owner.name} #YOOR`}
                      url={shareUrl}
                      resetButtonStyle={true}
                    >
                      <img src={LineLogo} alt="line" />
                    </LineShareButton>
                  </li>
                  <li>
                    <CopyToClipboard
                      text={shareUrl}
                      onCopy={() =>
                        dispatch(
                          alertModules.actions.setAlert({
                            text: 'クリップボードにコピーしました',
                            severity: 'success'
                          })
                        )
                      }
                    >
                      <img src={LinkIcon} alt="clipboard" />
                    </CopyToClipboard>
                  </li>
                </SocialButtons>
              </div>
            </div>
          </>
          ) :
          (
            <>
              <div className="modal-contents" style={{paddingBottom: '40px'}}>
                <div style={{textAlign: 'center', fontWeight: 'bold',margin:'32px 0 40px'}}>
                  サロンを公開しますか？
                </div>
                <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                  <button onClick={handleClose} disabled={disabled} className="textLink" style={{color: '#999', margin: '0 32px'}}>キャンセル</button>
                  <button onClick={handlePublish} disabled={disabled} className="btn" style={{width: '160px'}}>公開</button>
                </div>
              </div>
            </>
          )
        }
      </section>
    </Dialog>
  )
}

const SocialButtons = styled.ul`
  display: flex;
  align-items: center;
  justify-content: center;
  gap 0px 24px;
  li {
    cursor: pointer;
    :hover {
      opacity: 0.4;
    }
  }
  img {
    width: 48px;
    height: 48px;
  }
`
